import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const PATH_TEMPLATE = '/workflow-reports/creators/{creatorId}/documents-report';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const getDocumentReport = async ({ creatorId, startDate, endDate, teamMembers }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/workflow-reports/creators/${creatorId}/documents-report`, {
    endDate,
    startDate,
    teamMembers,
  });
  return response.data;
};

export default getDocumentReport;
